import { useContext } from "react";
import MainContext from "../../../context/mainContext";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import Typography from "@mui/material/Typography";

export default function SubtitleOneTranslations(props) {
  const { subtitleStylesData } = useContext(MainContext);
  const { dict, loadingSub } = props;
  return (
    <List disablePadding dense sx={{ width: "100%" }}>
      {!loadingSub ? (
        ""
      ) : !dict ? (
        <Typography>در حال بارگزاری ترجمه ها</Typography>
      ) : (
        dict[0]["translations"].slice(0, 3).map((value, index) => (
          <ListItem
            key={`tranlate-${index}`}
            secondaryAction={<></>}
            sx={{ p: 0, m: 0 }}
            onClick={() => {
              console.log("value3", value);
            }}
          >
            <ListItemText
              primaryTypographyProps={{
                color: subtitleStylesData[`subdict_color`] || "black",
                fontSize:
                  `${subtitleStylesData[`subdict_fontSize`]}px` || "15px",
              }}
              primary={` -${value} `}
            />
          </ListItem>
        ))
      )}
    </List>
  );
}
